import React from 'react';

import usePreviousSeasonOfferingDropdown from './UsePreviousSeasonOfferingDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const PreviousSeasonOfferingDropdown = ({ label, name, value, error, message, onChange, isAthleteRole }) => {
  const { previousSeasonOfferingState } = usePreviousSeasonOfferingDropdown(isAthleteRole);

  return previousSeasonOfferingState.message
    ? <span className={global.LoadingMsg}>{previousSeasonOfferingState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={previousSeasonOfferingState.options}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={previousSeasonOfferingState.isArrayLoading} />
    );
};

export default PreviousSeasonOfferingDropdown;